import React, { createContext, useState } from 'react'

export const LabelContext = createContext()

const LabelContextProvider = ({ children }) => {
    const [label, setLabel] = useState(null)

    const changeLabel = label => {
        setLabel(label)
    }

    const contextValues = {
        label,
        changeLabel,
    }

    return <LabelContext.Provider value={contextValues}>{children}</LabelContext.Provider>
}
export default LabelContextProvider
